<template lang="pug">
v-container
  v-card.pointer(v-if="availableYears.length" v-for="item in availableYears" :key="item.id" class="mx-auto mb-1" max-width="400" @click.native="goNext(item)")
    v-card-title {{ item }}
      span.ellipse.mg-act( v-if="hasNewAgreement && notViewedMyAgreement.some(el => el.year == item)" )
</template>
<script>
import { mapState, mapActions } from "vuex";


export default {
  name: 'ChooseAgreementYear',
  computed: {
    ...mapState("agreement", ['availableYears', 'notViewedMyAgreement']),

    hasNewAgreement() {
      return this.notViewedMyAgreement && this.notViewedMyAgreement.length
    }
  },

  beforeMount() {
    this.loadAvailableYears()
  },

  methods: {
    ...mapActions("agreement", ['loadAvailableYears']),
    goNext(item){
      this.$router.push(`/personalAccount/agreementyears/${item}/months`)
    },
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mg-act {
  margin-left: 5px;
  margin-bottom: 17px;
}
</style>